// extracted by mini-css-extract-plugin
export default {"header":"header_header__1yI2O","logoutButton":"header_logoutButton__Cw68B","title":"header_title__kx3oq"};